import {Component, HostListener} from '@angular/core';
import {NGXLogger} from "ngx-logger";
import moment from "moment";
import {MatTooltipModule} from "@angular/material/tooltip";
import {RouterLink} from "@angular/router";
import {openPrivacyConsent} from '../../../shared/analytics/privacy-consent';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    MatTooltipModule,
    RouterLink
  ]
})
export class FooterComponent {
  currentYear = moment().get('year');
  // 모바일에서는 회사·고객지원·특허 정보를 접어서 푸터의 초기 높이를 줄인다.
  isMobile = typeof window !== 'undefined' && window.innerWidth <= 599;

  constructor(private readonly log: NGXLogger) {}

  openChat(url: string) {
    this.log.debug('Chat Url', url);
    window.open(url, '1 : 1', 'scrollbars=1, resizable=1, width=486, height=745');
  }

  openAnalysisSettings(): void {
    openPrivacyConsent();
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 599;
  }
}
